
import { Role, UserManagement, UserManagementAddForm } from "../types/user-management";
import { callApiInstance } from "./api";


const url = '/UserManagement'

class UserManagementService {



  async getAllUserManagement(): Promise<UserManagement[]> {
    return (await callApiInstance({ url })).data;
  }

  async editUserRoles(id: number, data: Role[]) {
    return (await callApiInstance({ url: `${url}/${id}`, method: "PUT", data })).data;
  }
  async addUser(data: UserManagementAddForm): Promise<{ data: UserManagement, status: number, ok: boolean }> {
    return (await callApiInstance({ url, method: "POST", data }));
  }
  async getSignature(): Promise<string> {
    return (await callApiInstance({ url: `${url}/getSignature` })).data;
  }
  async getCurrentUserExtraData(email: string): Promise<{ data: UserManagement, status: number, ok: boolean }> {
    return (await callApiInstance({ url: `${url}/UserByEmail?email=${email}` }));
  }

  // async getAllDrawRequests(status: "approve" | "deny" | "" | null, startDate: string, endDate: string): Promise<DrawRequest[]> {
  //   return (await callApiInstance({ url: `/DrawRequest?status=${status}&startDate=${startDate}&endDate=${endDate}` })).data;
  // }
  // async approveAllRequests(data: DrawRequest[]) {
  //   return (await callApiInstance({
  //     url: "/DrawRequest/ApproveAllDrawRequest",
  //     method: "POST",
  //     data
  //   })).data;
  // }
  // async createDrawRequest(data: CreateDrawRequest) {
  //   return (await callApiInstance({ url: "/DrawRequest", method: "POST", data })).data;
  // }

  // async editDrawRequest(id: number, data: CreateDrawRequest) {
  //   return (await callApiInstance({ url: `/DrawRequest/${id}`, method: "PUT", data })).data;
  // }

}
export const userManagementService = new UserManagementService();
